import { Grid, Skeleton } from "@mui/material";

const styles = {
  progressContainer: {
    width: "100%",
    pt: 4,
  },
};

const ScheduledThreadPreviewSkeleton = () => {
  return (
    <Grid
      container
      sx={styles.progressContainer}
      gap={2}
      alignItems="center"
      justifyContent="center"
    >
      <Skeleton animation="wave" variant="rounded" height={40} width="90%" />
      <Skeleton animation="wave" variant="rounded" height={30} width="90%" />
      <Skeleton animation="wave" variant="rounded" height={400} width="90%" />
    </Grid>
  );
};

export default ScheduledThreadPreviewSkeleton;
